import { browserRuntimeFreeze } from 'oidc-spa/browser-runtime-freeze'
import { oidcEarlyInit } from 'oidc-spa/entrypoint'

// Initialize OIDC early: intercepts the authentication callback before any
// other code runs (oidc-spa v10 requirement — same pattern as the reference).
const { shouldLoadApp } = oidcEarlyInit({
  // The path where the app is hosted
  BASE_URL: import.meta.env.BASE_URL || '/',

  securityDefenses: {
    // Prevent monkey-patching of browser APIs. `Object` is excluded (the
    // doc-sanctioned escape hatch): `temporal-polyfill` legitimately defines
    // `toLocaleString` on its own class prototypes at import time, which the
    // Object.prototype freeze trap would otherwise block — Temporal is the
    // binding date convention (engineering-standards frontend policy).
    ...browserRuntimeFreeze({ excludes: ['Object'] }),

    // DPoP disabled: the API uses standard JWT Bearer auth (parity with reference).
  },
})

if (shouldLoadApp) {
  // Defer loading the main application — speeds up the auth callback path.
  import('./main.lazy')
}
